import * as d3Array from "d3-array";
import resize from "vue-resize-directive";
import { tween } from "../utils/tva-tween.js";

export default {
  computed: {
    tmpMaxMinY() {
      let tmp = [];
      let data = this.stacked ? this.stackedData : this.data;
      data.forEach((datum) => {
        this.config.series.forEach((serie) => {
          tmp.push(datum[serie.key]);
        });
      });
      let max = Math.max(...tmp);
      let min = Math.min(...tmp);
      return {
        max: +max,
        min: +min,
      };
    },
    maxMinX() {
      let tmp = [];
      let data = this.stacked ? this.stackedData : this.data;
      data.forEach((datum) => {
        tmp.push(datum[this.config.xAxis]);
      });
      let max = Math.max(...tmp);
      let min = Math.min(...tmp);
      return {
        max: +max,
        min: +min,
      };
    },
    maxMinR() {
      let tmp = [];
      this.data.forEach((datum) => {
        tmp.push(datum["size"]);
      });
      let max = Math.max(...tmp);
      let min = Math.min(...tmp);
      return {
        max: +max,
        min: +min,
      };
    },
    ticksX() {
      let res = d3Array.ticks(
        this.maxMinX.min,
        this.maxMinX.max,
        this.config.xAxisTicksAmount
          ? this.config.xAxisTicksAmount
          : this.data.length
      );

      let sorted = res.sort((a, b) => +a - +b);
      return sorted;
    },
    ticksY() {
      let res = d3Array.ticks(
        this.tmpMaxMinY.min >= 0 ? 0 : this.tmpMaxMinY.min,
        this.tmpMaxMinY.max,
        this.config.yAxisTicksAmount
      );

      let sorted = res.sort((a, b) => +a - +b);

      let interval = Math.abs(Math.abs(sorted[1]) - Math.abs(sorted[0]));

      if (this.tmpMaxMinY.min <= sorted[0] && this.tmpMaxMinY.min !== 0) {
        sorted.unshift(sorted[0] - interval);
      }

      if (this.tmpMaxMinY.max >= sorted[sorted.length - 1]) {
        sorted.push(sorted[sorted.length - 1] + interval);
      }

      return sorted;
    },
    stackedData() {
      let res = [];
      this.data.forEach((d, i) => {
        let values = {};
        let tot = 0;

        this.config.series.forEach((s) => {
          let value = this.computedData[i]
            ? +this.computedData[i][s.key]
            : null;

          if (value !== null) tot += value;

          values[s.key] = tot;
          values[s.key + "_label"] = value;
        });

        res[i] = {
          ...{ [this.config.xAxis]: d[this.config.xAxis] },
          ...values,
        };
      });
      return res;
    },
  },
  data() {
    return {
      width: 0,
      height: 0,
      computedData: [],
      maxMinY: [{ max: 0, min: 0 }],
      tooltipMove: null,
      stacked: false,
    };
  },
  created() {
    if (this.data.length) {
      this.tweenData(this.data);
      this.tweenMaxMinY();
    }
  },
  watch: {
    data(data) {
      this.tweenData(data);
      this.tweenMaxMinY();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.setDimensions();
    });
  },
  methods: {
    tweenData(newData) {
      this.setComputedData();

      let keys = [];
      this.config.series.forEach((s) => {
        keys.push(s.key);
      });
      // this.tween({
      //   prop: this.computedData,
      //   keys,
      //   start: this.computedData,
      //   end: newData,
      //   duration: 3000,
      //   ease: "easeInOutCubic"
      // });
      this.computedData = newData;
    },
    tweenMaxMinY() {
      if (this.maxMinY[0].min === 0 && this.maxMinY[0].max === 0) {
        this.maxMinY = [
          { max: this.ticksY[this.ticksY.length - 1], min: this.ticksY[0] },
        ];
      } else {
        this.tween({
          prop: this.maxMinY,
          keys: ["max", "min"],
          start: this.maxMinY,
          end: [
            { max: this.ticksY[this.ticksY.length - 1], min: this.ticksY[0] },
          ],
          duration: 1000,
          ease: "easeInOutCubic",
        });
      }
    },
    setComputedData() {
      this.data.forEach((d, i) => {
        let values = {};

        this.config.series.forEach((s) => {
          let value = this.computedData[i] ? this.computedData[i][s.key] : null;

          if (value !== null) {
            values[s.key] = value;
          } else {
            values[s.key] = 0;
          }
        });

        this.$set(this.computedData, i, {
          ...d,
          ...{ [this.config.xAxis]: d[this.config.xAxis] },
          ...values,
        });
      });
    },
    setDimensions() {
      const component = this.$refs.component;
      this.width = component.getBoundingClientRect().width;
      this.height = component.getBoundingClientRect().height;
    },
    onResize() {
      this.setDimensions();
    },
    format(value) {
      return (+value)
        .toFixed(this.config.globalDecimals)
        .toLocaleString(this.config.globalLanguage);
    },
    tween,
  },
  directives: {
    resize,
  },
};
